export default __webpack_public_path__ + "55794a4c43803e64ae6942d66d636eea.jpg";